import { useMemo } from 'react';
import type { AttachmentsResponse } from '@shared/api/rest/messages';
import { Button, Icon, Text } from '@shared/widgets';
import FileIcon from '@assets/icons/file.svg';
import CloseIcon from '@assets/icons/close.svg';
import DownloadIcon from '@assets/icons/download.svg';

export interface IMessageFileProps {
  attachment: Partial<AttachmentsResponse>;
  downloadShow?: boolean;
  onRemove?: () => void;
  onDownload?: () => void;
}

export const File = (props: IMessageFileProps) => {
  const fileSizeKb = useMemo(() => {
    if (props.attachment.fileSizeBytes) return Math.round(props.attachment.fileSizeBytes / 1024);
    return;
  }, [props.attachment]);

  if (!props.attachment) return null;
  return (
    <div className='max-w-[293px]'>
      <div className='relative m-0 inline-flex h-10 w-full max-w-full items-center justify-between gap-2 rounded-sm border-b border-b-light bg-ice pl-3 text-eerie-black hover:bg-white dark:border-b-primary dark:bg-soft-black dark:text-ice'>
        <div className='h-5 w-5 flex-none'>
          <FileIcon />
        </div>
        <Text className='max-w-[160px] flex-[inherit] overflow-hidden text-ellipsis whitespace-nowrap' weight='light' size='sm'>
          {props.attachment.filename}
        </Text>
        {typeof fileSizeKb === 'number' && (
          <Text className='relative top-[1px] flex-none whitespace-nowrap opacity-60' size='xs'>
            {fileSizeKb}kb
          </Text>
        )}
        {props.onRemove && (
          <Button className='!px-0 !pr-3' onClick={props.onRemove}>
            <Icon icon={<CloseIcon width='10' height='10' />} />
          </Button>
        )}
        {!props.downloadShow && (
          <Button
            color='primary'
            className='absolute right-[-1px] top-[-1px] mr-[-1px] flex h-10 w-11 items-center justify-center rounded-l-[0] rounded-r-[2px] !p-0 text-center text-xl'
            onClick={props.onDownload}
          >
            <Icon icon={<DownloadIcon />} color='inherit' />
          </Button>
        )}
      </div>
    </div>
  );
};
